import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { InputTextarea } from "primereact/inputtextarea"
import kioskStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import styles from "../../../../styles/kiosk/KioskParticipantManagement.module.css"
import { useFormik } from "formik"
import { getFormErrorMessage, isFormFieldValid } from "../helpers/helpers"
import { useContext, useEffect } from "react"
import { UserContext } from "../../../../context/userContext"
import { LogError } from "../../../../helpers/logger"
import { kioskApiPostParticipantsSignInNote } from "../../kioskApi"

const SignInNoteModal = ({
  show,
  setShow,
  selectedParticipant,
  setSelectedParticipant,
  kiosk_organization_id,
  refreshList,
}) => {
  const userCtx = useContext(UserContext)

  useEffect(() => {
    if (selectedParticipant) {
      formik.setFieldValue("showSignInNote", selectedParticipant.showSignInNote)
      formik.setFieldValue("note", selectedParticipant.signInNote || "")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedParticipant])

  const formik = useFormik({
    initialValues: {
      note: "",
      showSignInNote: false,
    },
    validate: (data) => {
      let errors = {}
      if (!data.note && data.showSignInNote) {
        errors.note = "If show note is active, the note is required."
      }
      return errors
    },
    onSubmit: (data) => {
      signInNoteParticipant(data)
    },
  })
  const signInNoteParticipant = async (data) => {
    try {
      const payload = {
        organizationId: kiosk_organization_id,
        participantIds: [selectedParticipant?.participantId],
        signInNote: formik.values.note,
        showSignInNote: formik.values.showSignInNote,
        participantMembershipId: selectedParticipant?.participantMembershipId,
      }

      await kioskApiPostParticipantsSignInNote(userCtx.tokenKiosk, payload)
      clean()
      refreshList(true)
    } catch (error) {
      LogError(
        "Unable to apply participant sign in note configuration values",
        error
      )
      userCtx.setNotificationError(
        "Unable to apply participant sign in note configuration values"
      )
      clean()
    }
  }
  const clean = () => {
    formik.resetForm()
    formik.setSubmitting(false)
    setSelectedParticipant(null)
    setShow(false)
  }
  const headerText = () => {
    return <label>Sign in note</label>
  }
  return (
    <Dialog visible={show} showHeader={false} style={{ width: "40vw" }}>
      <div className={kioskStyles.modalHeader}>
        {headerText()}
        <Button
          icon="pi pi-times"
          className={kioskStyles.hideModalButton}
          onClick={() => {
            clean()
          }}
          disabled={formik.isSubmitting}
        />
      </div>
      <div className={kioskStyles.modalFormContainer}>
        <hr className={kioskStyles.modalHeaderLine} />
        <form onSubmit={formik.handleSubmit}>
          <div className={kioskStyles.modalField}>
            <label className={kioskStyles.modalFieldLabel}>
              Note<i className="pi pi-info-circle"></i>
            </label>
            <InputTextarea
              style={{ width: "100%" }}
              autoResize
              name="note"
              value={formik.values.note}
              onChange={formik.handleChange}
              rows={5}
              cols={30}
              placeholder="Your profile is currently locked"
              className={`${styles.lockedMessageInput} ${
                isFormFieldValid(formik, "note") && kioskStyles.inputError
              }`}
              disabled={formik.isSubmitting}
            />
            {getFormErrorMessage(formik, "note")}
            <div
              className={`${styles.checkboxContainer} ${styles.checkboxContainerWithBorder}`}
            >
              <Checkbox
                id="showSignInNote"
                name="showSignInNote"
                onChange={formik.handleChange}
                checked={formik.values.showSignInNote}
                className={kioskStyles.checkboxInput}
                disabled={formik.isSubmitting}
              />
              <label htmlFor="notExpire" className="ml-2">
                Show note at next sign in
              </label>
            </div>
          </div>
          <div className={kioskStyles.modalField}>
            <div className={styles.info}>
              <i className="pi pi-info-circle" style={{ fontSize: "18px" }}></i>
              <label>
                Once the show note at next sign in is selected and saved, the
                note will show only once at the immediate next sign in and then
                deactivate
              </label>
            </div>
          </div>
          <div className={kioskStyles.modalFooter}>
            <Button
              label="Cancel"
              className={`${kioskStyles.modalFooterButton} ${kioskStyles.modalCancelButton}`}
              onClick={() => {
                clean()
              }}
              disabled={formik.isSubmitting}
              type="button"
            />
            <Button
              icon={formik.isSubmitting && "pi pi-spin pi-spinner"}
              label={"Save"}
              type="submit"
              disabled={formik.isSubmitting}
              className={kioskStyles.modalFooterButton}
            />
          </div>
        </form>
      </div>
    </Dialog>
  )
}
export default SignInNoteModal
